import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useCloudSecurity } from '../context/CloudSecurityContext';

const shineAnimation = keyframes`
  0% { left: -100%; }
  100% { left: 100%; }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const ProviderButton = styled.button`
  padding: 15px 30px;
  background: ${props => props.active ? 
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 
    '#1a1f3a'};
  border: 2px solid ${props => props.active ? 'transparent' : '#2d3561'};
  color: #e0e6ed;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1em;
  position: relative;
  overflow: hidden;
  box-shadow: ${props => props.active ? 
    '0 5px 20px rgba(102, 126, 234, 0.5)' : 
    'none'};
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
    border-color: #667eea;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.3), transparent);
    transition: left 0.5s;
  }
  
  &:hover::before {
    animation: ${shineAnimation} 0.5s;
  }
  
  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 1em;
  }
`;

const ProviderSelector = () => {
  const { currentProvider, selectProvider } = useCloudSecurity();

  const providers = [
    { id: 'aws', name: 'AWS', icon: '☁️' },
    { id: 'azure', name: 'Azure', icon: '🔷' },
    { id: 'gcp', name: 'Google Cloud', icon: '🌐' },
    { id: 'alibaba', name: 'Alibaba Cloud', icon: '🐉' },
    { id: 'ibm', name: 'IBM Cloud', icon: '🔵' },
    { id: 'oracle', name: 'Oracle Cloud', icon: '🔴' },
    { id: 'multi', name: 'Multi-Cloud', icon: '🔀' }
  ];

  return (
    <Container>
      {providers.map(provider => (
        <ProviderButton
          key={provider.id}
          active={currentProvider === provider.id}
          onClick={() => selectProvider(provider.id)}
        >
          {provider.icon} {provider.name}
        </ProviderButton>
      ))}
    </Container>
  );
};

export default ProviderSelector; 